import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsHikeNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M5.75 12.88l.24-.24a.329.329 0 01.46-.01l.24.25a2.18 2.18 0 001.5.62h1.63l-.72-1h-.91a1.13 1.13 0 01-.79-.33l-.24-.24a1.315 1.315 0 00-1.87 0l-.24.24c-.213.21-.5.328-.8.33h-.06l-.72 1h.78a2.119 2.119 0 001.5-.62z"
        fill=""
      />
      <path
        d="M2.24 13.49l.72-.99h-.58a.876.876 0 01-.88-.88 5.98 5.98 0 01.1-1.12h2.8l.72-1H1.78v-.02l.15-.7a1.52 1.52 0 01.74-.99L6.5 5.65V4.51L2.29 6.86l.21-1.09a1.462 1.462 0 01.72-.99l2.12-1.17.38-.76a.567.567 0 01.5-.31A1.287 1.287 0 017.5 3.82V7.9l1 .53V6.9c.033.03.07.053.11.07l.89.47v1.52l1 .54V7.98l1 .53v1.52l1 .53V9.04l.37.2h1.12a.512.512 0 01.51.51 2.747 2.747 0 01-2.75 2.75h-1.42l.72 1h.7a3.751 3.751 0 003.75-3.75 1.515 1.515 0 00-1.51-1.51h-.87L9.08 6.09a1.084 1.084 0 01-.58-.96V3.82a2.285 2.285 0 00-2.28-2.28 1.543 1.543 0 00-1.39.86l-.25.49-1.84 1.02a2.43 2.43 0 00-1.22 1.67l-.87 4.45c-.1.524-.15 1.056-.15 1.59a1.87 1.87 0 001.74 1.87z"
        fill=""
      />
    </svg>
  )
);
SvgSportsHikeNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgSportsHikeNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsHikeNormalXsmall;
